import { IMap } from 'annotation-tools/utils';
import { pathnameElements } from '../../../routing/routes';
import { commonViewTexts as vt } from '../common';

export const pathDisplayName = IMap<string, string>([
  [pathnameElements.koumutens, `${vt.koumuten}一覧`],
  [pathnameElements.companies, `${vt.company}一覧`],
  [pathnameElements.images, `${vt.blueprintData}管理`],
  [pathnameElements.labels, `${vt.label}一覧`],
  [pathnameElements.login, 'ログイン'],
  [pathnameElements.models, `${vt.model}一覧`],
  [pathnameElements.projects, `${vt.project}一覧`],
  [pathnameElements.summary, '概要'],
  [pathnameElements.users, `${vt.user}一覧`],
  [pathnameElements.csvs, `${vt.csv}一覧`]
]);
